"use client";
import { useRef, useEffect } from 'react';

const createRootElement = (id) => {
    let rootContainer = null;
    /* istanbul ignore else -- @preserve */
    if (typeof window !== 'undefined') {
        rootContainer = document.createElement('div');
    }
    /* istanbul ignore else -- @preserve */
    if (rootContainer) {
        rootContainer.setAttribute('id', id);
    }
    return rootContainer;
};
const addRootElement = (rootElem) => {
    var _a;
    /* istanbul ignore else -- @preserve */
    if (typeof window !== 'undefined') {
        document.body.insertBefore(rootElem, ((_a = document.body.lastElementChild) === null || _a === void 0 ? void 0 : _a.nextElementSibling) || null);
    }
};
const usePortal = (id) => {
    const rootElemRef = useRef(null);
    useEffect(() => {
        /* istanbul ignore else -- @preserve */
        if (typeof window !== 'undefined') {
            const existingParent = document.getElementById(id);
            const parentElem = existingParent || createRootElement(id);
            /* istanbul ignore else -- @preserve */
            if (!existingParent) {
                addRootElement(parentElem);
            }
            /* istanbul ignore else -- @preserve */
            if (rootElemRef.current) {
                parentElem.appendChild(rootElemRef.current);
            }
            return function removeElement() {
                /* istanbul ignore else -- @preserve */
                if (rootElemRef.current) {
                    rootElemRef.current.remove();
                }
                /* istanbul ignore else -- @preserve */
                if (parentElem && !parentElem.childElementCount) {
                    parentElem.remove();
                }
            };
        }
    }, [id]);
    const getRootElem = () => {
        /* istanbul ignore else -- @preserve */
        if (!rootElemRef.current) {
            rootElemRef.current = null;
            /* istanbul ignore else -- @preserve */
            if (typeof window !== 'undefined') {
                rootElemRef.current = document.createElement('div');
            }
        }
        return rootElemRef.current;
    };
    return getRootElem();
};

export { usePortal as default };
